var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnquiredStudents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33569 42.8389L13.0684 45.8333L14.2103 43.2612L7.51473 40.1836L6.33569 42.8389Z",
    fill: "url(#paint0_linear_1044_29751)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6666 17.5C36.6666 23.0141 32.1807 27.5 26.6666 27.5C21.1525 27.5 16.6666 23.014 16.6666 17.5C16.6666 11.9859 21.1526 7.5 26.6666 7.5C32.1808 7.5 36.6666 11.986 36.6666 17.5ZM31.5049 11.9186C31.2995 12.124 31.2995 12.4573 31.5049 12.6627C34.1722 15.3304 34.1722 19.6711 31.5045 22.3395C31.1723 22.6717 31.4121 23.2379 31.8768 23.2379C32.0116 23.2379 32.1463 23.1864 32.249 23.0837C35.3271 20.0052 35.3271 14.9967 32.249 11.9186C32.0436 11.7132 31.7103 11.7132 31.5049 11.9186ZM21.8284 11.9182C21.623 11.7128 21.2897 11.7128 21.0843 11.9182C18.0066 14.9967 18.0066 20.0049 21.0843 23.083C21.2897 23.2884 21.623 23.2884 21.8284 23.083C22.0339 22.8772 22.0339 22.5439 21.8284 22.3384C19.1608 19.6708 19.1608 15.33 21.8284 12.6624C22.0339 12.4569 22.0339 12.1236 21.8284 11.9182ZM21.4679 17.4454C21.4679 14.6161 23.7828 12.3012 26.6121 12.3012C29.4414 12.3012 31.7563 14.6161 31.7563 17.4454C31.7563 20.2748 29.4414 22.5897 26.6121 22.5897C23.7828 22.5897 21.4679 20.2748 21.4679 17.4454ZM27.6409 14.9101C27.6409 14.4692 27.2735 14.1385 26.8693 14.1385C26.4284 14.1385 26.0977 14.4692 26.0977 14.9101C26.0977 15.351 26.4651 15.6817 26.8693 15.6817C27.3102 15.6817 27.6409 15.351 27.6409 14.9101ZM25.5097 19.8338C25.326 20.4585 25.8037 21.0831 26.4651 21.0831C27.053 21.0831 27.5674 20.7157 27.7511 20.1645H27.4205C27.1632 20.1645 26.9795 19.9441 27.053 19.6869L27.7144 17.4822C27.8981 16.8575 27.4205 16.2329 26.7591 16.2329C26.1711 16.2329 25.6567 16.6003 25.473 17.1515H25.8037C26.0609 17.1515 26.2446 17.372 26.1711 17.6292L25.5097 19.8338Z",
    fill: "url(#paint1_linear_1044_29751)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39817 21.9116C8.19139 21.9116 8.83674 21.2662 8.83674 20.473C8.83674 19.6798 8.19137 19.0344 7.39817 19.0344C6.60497 19.0344 5.95959 19.6798 5.95959 20.473C5.95925 21.2662 6.60462 21.9116 7.39817 21.9116Z",
    fill: "url(#paint2_linear_1044_29751)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6639 30.7574L32.7037 32.553C29.6285 33.9474 26.1129 33.961 23.0259 32.5881L22.265 32.2496C17.0286 29.9207 11.0001 32.3435 8.72898 37.4519L7.90479 39.308L14.6003 42.3856L15.1232 41.2075C15.9512 39.3459 18.1421 38.4803 20.0318 39.3208C22.8662 40.5812 26.097 40.5708 28.9244 39.2884L38.5532 34.9228C39.7827 34.3655 40.3181 32.8086 39.5388 31.6094C39.1115 30.9518 37.794 30.2449 36.6644 30.7573L36.6639 30.7574Z",
    fill: "url(#paint3_linear_1044_29751)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.366 11.3607C43.366 10.3031 42.5053 9.44238 41.4477 9.44238C40.39 9.44238 39.5293 10.3031 39.5293 11.3607C39.5293 12.4184 40.39 13.2791 41.4477 13.2791C42.5057 13.2791 43.366 12.4184 43.366 11.3607Z",
    fill: "url(#paint4_linear_1044_29751)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43895 33.6609C6.43895 34.0582 6.11678 34.38 5.71947 34.38C5.32217 34.38 5 34.0582 5 33.6609C5 33.2636 5.32217 32.9414 5.71947 32.9414C6.11678 32.9414 6.43895 33.2636 6.43895 33.6609Z",
    fill: "url(#paint5_linear_1044_29751)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8461 37.0178C43.8461 37.4151 43.5239 37.7373 43.1266 37.7373C42.7293 37.7373 42.4071 37.4151 42.4071 37.0178C42.4071 36.6205 42.7293 36.2983 43.1266 36.2983C43.5239 36.2983 43.8461 36.6205 43.8461 37.0178Z",
    fill: "url(#paint6_linear_1044_29751)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9684 20.2327C40.9684 20.63 40.6462 20.9518 40.2489 20.9518C39.8516 20.9518 39.5298 20.63 39.5298 20.2327C39.5298 19.8353 39.8516 19.5132 40.2489 19.5132C40.6462 19.5132 40.9684 19.8353 40.9684 20.2327Z",
    fill: "url(#paint7_linear_1044_29751)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6931 5.36561C35.6931 5.76292 35.3709 6.08508 34.9736 6.08508C34.5763 6.08508 34.2542 5.76292 34.2542 5.36561C34.2542 4.9683 34.5763 4.64648 34.9736 4.64648C35.3709 4.64648 35.6931 4.9683 35.6931 5.36561Z",
    fill: "url(#paint8_linear_1044_29751)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4688 4.88622C17.4688 5.28353 17.1469 5.60569 16.7496 5.60569C16.3523 5.60569 16.0302 5.28353 16.0302 4.88622C16.0302 4.48891 16.3523 4.16675 16.7496 4.16675C17.1469 4.16675 17.4688 4.48891 17.4688 4.88622Z",
    fill: "url(#paint9_linear_1044_29751)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3574 12.0796C8.3574 12.4769 8.03524 12.7991 7.63793 12.7991C7.24062 12.7991 6.91846 12.4769 6.91846 12.0796C6.91846 11.6823 7.24062 11.3601 7.63793 11.3601C8.03524 11.3601 8.3574 11.6823 8.3574 12.0796Z",
    fill: "url(#paint10_linear_1044_29751)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1119 24.0695C14.1119 24.4668 13.7898 24.7889 13.3925 24.7889C12.9952 24.7889 12.6733 24.4668 12.6733 24.0695C12.6733 23.6722 12.9952 23.3503 13.3925 23.3503C13.7898 23.3503 14.1119 23.6722 14.1119 24.0695Z",
    fill: "url(#paint11_linear_1044_29751)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1722 42.293C36.1722 42.6903 35.8504 43.0124 35.4531 43.0124C35.0558 43.0124 34.7336 42.6903 34.7336 42.293C34.7336 41.8957 35.0558 41.5735 35.4531 41.5735C35.8504 41.5735 36.1722 41.8957 36.1722 42.293Z",
    fill: "url(#paint12_linear_1044_29751)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1044_29751",
    x1: 6.33569,
    y1: 43.0085,
    x2: 14.2103,
    y2: 43.0085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1044_29751",
    x1: 16.6666,
    y1: 17.5,
    x2: 36.6666,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1044_29751",
    x1: 5.95959,
    y1: 20.473,
    x2: 8.83674,
    y2: 20.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1044_29751",
    x1: 7.90479,
    y1: 36.4836,
    x2: 39.9034,
    y2: 36.4836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1044_29751",
    x1: 39.5293,
    y1: 11.3607,
    x2: 43.366,
    y2: 11.3607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1044_29751",
    x1: 5,
    y1: 33.6607,
    x2: 6.43895,
    y2: 33.6607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1044_29751",
    x1: 42.4071,
    y1: 37.0178,
    x2: 43.8461,
    y2: 37.0178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1044_29751",
    x1: 39.5298,
    y1: 20.2325,
    x2: 40.9684,
    y2: 20.2325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1044_29751",
    x1: 34.2542,
    y1: 5.36578,
    x2: 35.6931,
    y2: 5.36578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1044_29751",
    x1: 16.0302,
    y1: 4.88622,
    x2: 17.4688,
    y2: 4.88622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1044_29751",
    x1: 6.91846,
    y1: 12.0796,
    x2: 8.3574,
    y2: 12.0796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1044_29751",
    x1: 12.6733,
    y1: 24.0696,
    x2: 14.1119,
    y2: 24.0696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1044_29751",
    x1: 34.7336,
    y1: 42.293,
    x2: 36.1722,
    y2: 42.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnquiredStudents);
export default __webpack_public_path__ + "static/media/EnquiredStudents.41007d9c0faf178f85d3fc7ae7cfcb67.svg";
export { ForwardRef as ReactComponent };